import { Link, useLocation } from 'react-router-dom'
import { COLETOR_AREAS, contarProntos } from '../nav/coletor-nav'

/* ============================================================================
 * Coletor - Areas (1o nivel) | ADR-0034 F2b
 * As 4 areas da plataforma na mao. Cada card -> /m/area/:id.
 * Herda os tokens via .coletor-root (aplicado no MobileShell).
 * ========================================================================== */
export default function Areas() {
  const loc = useLocation()
  const qs = loc.search || ''

  return (
    <div className="py-3 select-none">
      <div className="px-1 mb-3">
        <div
          className="text-base font-semibold"
          style={{ color: 'var(--tx-primary)' }}
        >
          Movatic
        </div>
        <div className="text-xs" style={{ color: 'var(--tx-secondary)' }}>
          A plataforma na tua mao
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {COLETOR_AREAS.map((area) => {
          const Icon = area.icon
          const prontos = contarProntos(area)
          const total = area.modulos.length
          const eco = area.eco === true
          return (
            <Link
              key={area.id}
              to={`/m/area/${area.id}${qs}`}
              className="group relative p-4 tile-3d cursor-pointer"
              style={
                eco
                  ? {
                      background: 'var(--bg-eco)',
                      borderColor: 'var(--bd-eco)',
                    }
                  : undefined
              }
            >
              <div
                className="mb-3 w-10 h-10 rounded-xl flex items-center justify-center"
                style={{
                  background: eco
                    ? 'rgba(150,120,220,.15)'
                    : 'var(--bg-icon-tile)',
                }}
              >
                <Icon
                  size={22}
                  className="group-active:scale-95 transition-transform"
                  style={{
                    color: eco ? 'var(--col-eco)' : 'var(--col-action-ico)',
                  }}
                />
              </div>
              <div
                className="font-medium"
                style={{ color: 'var(--tx-primary)' }}
              >
                {area.label}
              </div>
              <div
                className="text-xs mt-0.5"
                style={{ color: 'var(--tx-secondary)' }}
              >
                {eco
                  ? `${total} a ligar`
                  : `${total} modulos · ${prontos} prontos`}
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
